// Matches both spellings of a SUNO merge tag: the `<!--SUNO:tag-->` comment (the storage/wire form
// the backend resolves) and the bracket-less `!--SUNO:tag--` that Unlayer emits, since it strips
// `<`/`>` off a merge-tag value.
//
// The capture is `[\w.]+`, not `.*?`: every registered token is snake_case or the dotted
// `PhysicianRecipient.Field` namespace, and a lazy `.*?` runs to the next `--` ANYWHERE on the
// line — so an unterminated `!--SUNO:foo` typed into an Unlayer HTML block would swallow the
// opener of the next well-formed tag and destroy both. `\s*` because the tag may arrive spaced.
const SUNO_PLACEHOLDER_RE = /(?:<!--SUNO:|!--SUNO:)\s*([\w.]+)\s*--(?:>)?/g;

/** Converts Unlayer SUNO placeholders to `{{tag}}` for preview and send. */
export const convertSunoPlaceholdersToMergeTags = (html: string): string =>
  html.replaceAll(SUNO_PLACEHOLDER_RE, "{{$1}}");

/** Normalizes SUNO placeholders to `<!--SUNO:tag-->` for storage. */
export const normalizeSunoPlaceholdersForStorage = (html: string): string =>
  html.replaceAll(SUNO_PLACEHOLDER_RE, "<!--SUNO:$1-->");
